function getPaddingBottom(value) {
    const [x, y] = value.split(':').map(Number);
    return `${(y / x) * 100}%`;
}

const directive = function ({ style }, { value }) {
    style.paddingBottom = getPaddingBottom(value);
};

const Plugin = {
    install(Vue) {
        Vue.directive('aspect-ratio', directive);
    },
};

export default Plugin;
export { directive };
